import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountCloudFiles implements ZIDXPage{

    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCloudFilesContainer";
    }
    render(){
        // console.log("cloud files");
    }
}